<template>
  <div>
    <el-card>
    <el-page-header style="margin-bottom: 20px" @back="goBack" />
    </el-card>
    <el-form ref="formRef" label-width="150px" :model="form" :rules="rules">
      <el-card>
        <el-form-item label="社群名称" prop="name">
          <el-col :span="8">
            <el-input v-model="form.name" placeholder="请输入社群名称" maxlength="100" show-word-limit />
          </el-col>
        </el-form-item>
        <el-form-item label="分类" prop="categoryId">
          <el-cascader
            v-model="form.categoryId"
            :options="categoryTree"
            :props="categoryCascaderProps"
            clearable
            placeholder="请选择分类"
            popper-class="community-category-cascader"
            style="width: 400px"
          />
        </el-form-item>
        <el-form-item label="摘要" prop="summary">
          <el-col :span="10">
            <el-input v-model="form.summary" type="textarea" :rows="3" placeholder="请输入摘要" maxlength="300" show-word-limit />
          </el-col>
        </el-form-item>
        <el-form-item label="行业标签" prop="industryIds">
          <div class="industry-field" style="width: 400px">
            <div v-if="selectedIndustries.length" class="selected-industry-tags">
              <el-tag
                v-for="item in selectedIndustries"
                :key="item.id"
                closable
                size="small"
                @close="removeIndustry(item.id)"
              >
                {{ item.name }}
              </el-tag>
            </div>
            <el-select
              v-model="industryPick"
              filterable
              remote
              reserve-keyword
              clearable
              :disabled="form.industryIds.length >= 2"
              :remote-method="searchIndustry"
              :loading="industryLoading"
              placeholder="请输入关键词搜索行业标签（最多2个）"
              style="width: 100%"
              @change="onIndustryPick"
            >
              <el-option
                v-for="item in industryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="form.industryIds.some((id) => id == item.id)"
              />
              <template slot="empty">
                <div class="select-empty-box">
                  <p v-if="!industryKeyword">无数据</p>
                  <template v-else>
                    <p>无匹配数据</p>
                    <el-button
                      type="text"
                      :loading="industryCreating"
                      @mousedown.native.prevent
                      @click="createIndustry"
                    >
                      新增行业标签「{{ industryKeyword }}」
                    </el-button>
                  </template>
                </div>
              </template>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="运营标签" prop="operationTagId">
          <el-select
            ref="tagSelectRef"
            v-model="form.operationTagId"
            filterable
            remote
            clearable
            :remote-method="searchTag"
            :loading="tagLoading"
            placeholder="请输入关键词搜索运营标签"
            style="width: 400px"
          >
            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="Number(item.id)" />
            <template slot="empty">
              <div class="select-empty-box">
                <p v-if="!tagKeyword">无数据</p>
                <template v-else>
                  <p>无匹配数据</p>
                  <el-button
                    type="text"
                    :loading="tagCreating"
                    @mousedown.native.prevent
                    @click="createTag"
                  >
                    新增运营标签「{{ tagKeyword }}」
                  </el-button>
                </template>
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="加入类型" prop="joinType">
          <el-select v-model="form.joinType" placeholder="请选择加入类型">
            <el-option label="免费" :value="1" />
            <el-option label="开通VIP" :value="2" />
            <el-option label="付费" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.joinType == 1" label="是否需要查看广告" prop="viewAd">
          <el-radio-group v-model="form.viewAd">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      
        <el-form-item v-if="form.joinType == 3" label="价格" prop="price">
          <el-select v-model="form.price" placeholder="请选择价格" style="width: 400px">
            <el-option
              v-for="(item, index) in priceOptions"
              :key="index"
              :label="item.title"
              :value="item.price"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="成员上限" prop="memberLimit">
                     <el-input-number v-model="form.memberLimit" :min="0" />

          <span class="waring ml">0为不限人数</span>
        </el-form-item>
      </el-card>

      <el-card>
        <!-- <el-form-item label="热门">
          <el-radio-group v-model="form.hot">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="推荐">
          <el-radio-group v-model="form.recommend">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          
          <el-col :span="4" style="display: flex; align-items: center">
              <el-tooltip effect="dark" placement="top">
            <div slot="content">数值越大，显示越靠前</div>
            <i class="el-icon-warning-outline" style="margin-left: 5px" />
          </el-tooltip>
            <el-input-number style="margin-left:10px" v-model="form.sort" :min="0" />
          </el-col>
        
        </el-form-item> -->
        <el-form-item label="群内活动主题" prop="notice">
          <el-col :span="10">
            <el-input v-model="form.notice" placeholder="请输入群内活动主题" maxlength="50" show-word-limit />
          </el-col>
        </el-form-item>
        <el-form-item label="群内活动开始时间" prop="noticeTime">
          <el-date-picker
              v-model="form.noticeTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择群内活动开始时间"
              style="width: 100%"
            />
                   <span class="waring ml"  style="margin-left:0">群内活动是指运营自己在微信群内做的活动，如快问快答、抽奖、发红包等等</span>

        </el-form-item>
       
      </el-card>
<el-card>
   <el-form-item label="关联活动">
          <fuzzy-selection
            ref="activityRef"
            tip-name="活动"
            :type="4"
            clearable
            :value.sync="form.activityId"
          />
                   <span class="waring ml" style="margin-left:0">这里是关联在扬帆平台已上线的活动，关联后会在活动详情页显示该群，群详情页也会显示关联活动。</span>

        </el-form-item>
         
</el-card>
      <el-card>
        <el-form-item label="主图" prop="banner">
          <up-img
            :action="{ action: 'community', ratio: '5:4' }"
            :banner="form.banner"
            :tip_text="false"
            the-text="请上传比例5:4的图片，否则会影响前台显示；大小不可超过1M，只允许上传jpg,jpeg,png格式的图片"
            @event="setImg('banner', $event)"
          />
        </el-form-item>
        <el-form-item label="背景图">
          <up-img :action="imgAction" :banner="form.backgroundImage" @event="setImg('backgroundImage', $event)" />
        </el-form-item>
        <el-form-item label="进群二维码">
          <up-img
            :action="{ action: 'community', ratio: '1:1' }"
            :banner="form.assistantQr"
            :tip_text="false"
            the-text="请上传比例1:1的图片，否则会影响前台显示；大小不可超过1M，只允许上传jpg,jpeg,png格式的图片"
            @event="setImg('assistantQr', $event)"
          />
        </el-form-item>
      </el-card>

      <el-card>
        <el-form-item label="社群详情" prop="content">
          <div class="tip" style="color: #fda400">
            单张图片大小不能超过1M，分辨率总和不能超过2亿，图片太长请分割多张图片上传！！！
          </div>
          <Tiny :value="form.content" @input="chang" />
        </el-form-item>
        <el-form-item label="进群须知" prop="payNotice">
          <el-col :span="10">
            <el-input v-model="form.payNotice" type="textarea" :rows="4" placeholder="请输入进群须知" />
          </el-col>
        </el-form-item>
        <el-form-item label="表单">
          <div class="tip" style="color: #fda400">
            系统默认已收集用户基本信息，到小程序【我的-编辑资料】中查看具体字段，不要在自定义表单中重复收集！！！
          </div>
          <activityFormEdit ref="activityFormEdit" @addActivityModel="addActivityModel" />
        </el-form-item>
      </el-card>

      <el-card>
        <el-form-item>
          <el-button v-if="!id" size="medium" type="primary" :loading="loading" @click="submit">提交</el-button>
          <el-button v-else size="medium" type="primary" :loading="loading" @click="submit">修改</el-button>
          <el-button size="medium" @click="goBack">返回</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import upImg from '@/components/upImg'
import fuzzySelection from '@/components/fuzzySelection'
import activityFormEdit from '@/views/activity/activity_form/activity_form_edit/index.vue'

export default {
  name: 'CommunityAdd',
  components: {
    upImg,
    fuzzySelection,
    activityFormEdit
  },
  data() {
    return {
      id: null,
      loading: false,
      categoryTree: [],
      categoryCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false,
        expandTrigger: 'hover'
      },
      industryList: [],
      tagList: [],
      industrySelectedMap: {},
      industryPick: '',
      industryKeyword: '',
      tagKeyword: '',
      industryLoading: false,
      tagLoading: false,
      industryCreating: false,
      tagCreating: false,
      configDictionaries: {},
      imgAction: { action: 'community' },
      form: this.getDefaultForm(),
      rules: {
        name: [{ required: true, message: '请输入社群名称', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        summary: [{ required: true, message: '请输入摘要', trigger: 'blur' }],
        industryIds: [{ required: true, message: '请选择行业', trigger: 'change', type: 'array' }],
        operationTagId: [{ required: true, message: '请选择运营标签', trigger: 'change' }],
        joinType: [{ required: true, message: '请选择加入类型', trigger: 'change' }],
        price: [{
          validator: (rule, value, callback) => {
            if (this.form.joinType != 3) {
              callback()
              return
            }
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请选择价格'))
              return
            }
            const options = this.priceOptions || []
            if (!options.length) {
              callback()
              return
            }
            const matched = options.some((item) => {
              return Number(item.price) === Number(value)
            })
            if (!matched) {
              callback(new Error('请选择价格'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        banner: [{ required: true, message: '请上传主图', trigger: 'change' }],
        content: [{ required: true, message: '请输入社群详情', trigger: 'blur' }]
      }
    }
  },
  computed: {
    priceOptions() {
      const dict = this.configDictionaries
      const list = Array.isArray(dict) ? dict : dict.communityPrice || dict.price || []
      return (list || []).map((item) => ({
        ...item,
        title: item.title || item.value || String(item.price),
        price: item.price != null && item.price !== '' ? Number(item.price) : item.price
      }))
    },
    selectedIndustries() {
      return (this.form.industryIds || []).map((id) => {
        const fromMap = this.industrySelectedMap[id] || this.industrySelectedMap[String(id)]
        if (fromMap) return fromMap
        const fromList = this.industryList.find((item) => item.id == id)
        return fromList || { id, name: String(id) }
      })
    }
  },
  created() {
    this.id = this.$route.query.id || null
    this.initPage()
  },
  methods: {
    async initPage() {
      await this.loadOptions()
      if (this.id) {
        await this.getDetail()
      }
    },
    getDefaultForm() {
      return {
        name: '',
        categoryId: '',
        summary: '',
        industryIds: [],
        operationTagId: '',
        joinType: 1,
        viewAd: 0,
        price:'',
        memberLimit: 500,
        hot: 0,
        recommend: 0,
        sort: 0,
        notice: '',
        noticeTime: '',
        activityId: '',
        banner: '',
        backgroundImage: '',
        assistantQr: '',
        content: '',
        payNotice: ''
      }
    },
    async loadOptions() {
      await Promise.all([this.searchIndustry(''), this.searchTag(''), this.loadConfigDictionaries()])
      await this.loadCategoryTree()
    },
    async loadConfigDictionaries() {
      const { data: res } = await this.$http.get('/admin/Common/getConfigDictionaries?config=community&type=community_price')
      if (res.errorCode == 200) {
        this.configDictionaries = res.data || {}
      }
    },
    async fetchOptionList(url, keyword = '') {
      try {
        const params = { page: 1, pageSize: 100 }
        if (keyword) params.keyword = keyword
        const { data: res } = await this.$http.get(url, { params })
        if (res.errorCode == 200) return res.data.list || []
      } catch (e) {
        return []
      }
      return []
    },
    async searchIndustry(keyword) {
      this.industryKeyword = (keyword || '').trim()
      this.industryLoading = true
      try {
        const list = await this.fetchOptionList('/admin/CommunityIndustry/getList', keyword)
        // 有搜索词时只展示接口结果，便于无数据时显示「新增」
        if (this.industryKeyword) {
          this.industryList = list
          return
        }
        const selectedIds = this.form.industryIds || []
        const selected = selectedIds
          .map((id) => this.industrySelectedMap[id] || this.industrySelectedMap[String(id)] || list.find((item) => item.id == id))
          .filter(Boolean)
        const rest = list.filter((item) => !selectedIds.some((id) => id == item.id))
        this.industryList = [...selected, ...rest]
      } finally {
        this.industryLoading = false
      }
    },
    resolveCreatedId(res, fallbackName, list) {
      const data = res && res.data
      if (data == null) return null
      if (typeof data === 'number' || typeof data === 'string') return Number(data)
      if (data.id != null) return Number(data.id)
      if (fallbackName && list && list.length) {
        const found = list.find((item) => item.name === fallbackName) || list[0]
        return found ? Number(found.id) : null
      }
      return null
    },
    async createIndustry() {
      const name = this.industryKeyword
      if (!name || this.industryCreating) return
      if (this.form.industryIds.length >= 2) {
        this.$message.warning('行业标签最多选择2个')
        return
      }
      this.industryCreating = true
      try {
        const { data: res } = await this.$http.post('/admin/CommunityIndustry/add', { name, sort: 0 })
        if (res.errorCode != 200) return
        this.$message.success(res.message || '新增成功')
        let id = this.resolveCreatedId(res)
        if (!id) {
          const list = await this.fetchOptionList('/admin/CommunityIndustry/getList', name)
          id = this.resolveCreatedId(res, name, list)
        }
        if (!id) {
          this.$message.warning('新增成功，请重新搜索并选择')
          await this.searchIndustry(name)
          return
        }
        this.industryList = [{ id, name }, ...this.industryList.filter((item) => item.id != id)]
        this.$set(this.industrySelectedMap, id, { id, name })
        this.onIndustryPick(id)
        this.industryKeyword = ''
      } finally {
        this.industryCreating = false
      }
    },
    onIndustryPick(id) {
      if (!id && id !== 0) return
      const numId = Number(id)
      if (this.form.industryIds.some((item) => item == numId)) {
        this.industryPick = ''
        return
      }
      if (this.form.industryIds.length >= 2) {
        this.$message.warning('行业标签最多选择2个')
        this.industryPick = ''
        return
      }
      const option = this.industryList.find((item) => item.id == numId)
      if (option) {
        this.$set(this.industrySelectedMap, numId, { id: numId, name: option.name })
      }
      this.form.industryIds = [...this.form.industryIds, numId]
      this.industryPick = ''
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('industryIds')
      })
    },
    removeIndustry(id) {
      this.form.industryIds = this.form.industryIds.filter((item) => item != id)
      this.$delete(this.industrySelectedMap, id)
      this.$delete(this.industrySelectedMap, String(id))
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('industryIds')
      })
    },
    async searchTag(keyword) {
      this.tagKeyword = (keyword || '').trim()
      this.tagLoading = true
      try {
        this.tagList = await this.fetchOptionList('/admin/CommunityOperationTag/getList', keyword)
      } finally {
        this.tagLoading = false
      }
    },
    async createTag() {
      const name = this.tagKeyword
      if (!name || this.tagCreating) return
      this.tagCreating = true
      try {
        const { data: res } = await this.$http.post('/admin/CommunityOperationTag/add', { name, sort: 0 })
        if (res.errorCode != 200) return
        this.$message.success(res.message || '新增成功')
        let id = this.resolveCreatedId(res)
        if (!id) {
          const list = await this.fetchOptionList('/admin/CommunityOperationTag/getList', name)
          id = this.resolveCreatedId(res, name, list)
        }
        if (!id) {
          this.$message.warning('新增成功，请重新搜索并选择')
          await this.searchTag(name)
          return
        }
        this.tagKeyword = ''
        // 先写入选项再赋值，避免输入框直接显示 id
        this.tagList = [{ id: Number(id), name }]
        this.form.operationTagId = ''
        await this.$nextTick()
        this.form.operationTagId = Number(id)
        this.$refs.tagSelectRef && this.$refs.tagSelectRef.blur()
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.validateField('operationTagId')
        })
      } finally {
        this.tagCreating = false
      }
    },
    async loadCategoryTree() {
      const { data: res } = await this.$http.get('/admin/CommunityCategory/getTree')
      if (res.errorCode == 200) {
        this.categoryTree = res.data || []
      }
    },
    normalizeIndustryIds(val) {
      let ids = []
      if (!val) return ids
      if (Array.isArray(val)) {
        ids = val.map(Number)
      } else if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val)
          if (Array.isArray(parsed)) ids = parsed.map(Number)
          else ids = val.split(',').filter(Boolean).map(Number)
        } catch (e) {
          ids = val.split(',').filter(Boolean).map(Number)
        }
      }
      return ids.slice(0, 2)
    },
    async ensureSelectedOptions(data) {
      const industryIds = this.normalizeIndustryIds(data.industryIds)
      if (industryIds.length) {
        const map = {}
        if (data.industries && data.industries.length) {
          data.industries.forEach((item) => {
            map[Number(item.id)] = { id: Number(item.id), name: item.name }
          })
        }
        industryIds.forEach((id) => {
          if (map[id]) {
            this.$set(this.industrySelectedMap, id, map[id])
          } else {
            const fromList = this.industryList.find((item) => item.id == id)
            if (fromList) this.$set(this.industrySelectedMap, id, { id, name: fromList.name })
          }
        })
        const missing = industryIds.filter((id) => !this.industryList.some((item) => item.id == id))
        if (missing.length) {
          const extras = missing
            .map((id) => this.industrySelectedMap[id])
            .filter(Boolean)
          this.industryList = [...extras, ...this.industryList]
        }
      }
      if (data.operationTagId && !this.tagList.some((item) => item.id == data.operationTagId)) {
        if (data.operationTagName) {
          this.tagList = [{ id: Number(data.operationTagId), name: data.operationTagName }, ...this.tagList]
        }
      }
    },
    async getDetail() {
      const { data: res } = await this.$http.get('/admin/Community/getById', {
        params: { id: this.id }
      })
      if (res.errorCode == 200) {
        const data = res.data || {}
        this.form = {
          ...this.getDefaultForm(),
          ...data,
          categoryId: data.categoryId ? Number(data.categoryId) : '',
          industryIds: this.normalizeIndustryIds(data.industryIds),
          operationTagId: data.operationTagId ? Number(data.operationTagId) : '',
          joinType: data.joinType != null ? Number(data.joinType) : 1,
          price: this.resolvePrice(data.price),
          activityId: data.activityId && data.activityId != 0 ? data.activityId : ''
        }
        await this.ensureSelectedOptions(data)
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate()
          this.setFormTemplates(data.forms)
          if (data.activityId && data.activityId != 0 && data.activityTitle) {
            if (this.$refs.activityRef) {
              this.$refs.activityRef.options = [{ id: data.activityId, title: data.activityTitle }]
            }
          }
        })
      }
    },
    resolvePrice(price) {
      if (price === '' || price === null || price === undefined) return ''
      const num = Number(price)
      if (Number.isNaN(num)) return price
      const option = this.priceOptions.find((item) => Number(item.price) === num)
      return option ? option.price : num
    },
    setFormTemplates(forms) {
      if (!forms || !this.$refs.activityFormEdit) return
      try {
        const list = typeof forms === 'string' ? JSON.parse(forms) : forms
        if (!Array.isArray(list)) return
        this.$refs.activityFormEdit.configFormData.list = list.map((item) => ({
          ...item,
          eleList: {
            list: typeof item.forms === 'string' ? JSON.parse(item.forms) : item.forms || [],
            config: { labelPosition: 'top', labelWidth: 100, size: 'small' }
          }
        }))
      } catch (e) {
        // ignore invalid forms json
      }
    },
    addActivityModel() {
      this.$confirm('此操作将导致数据丢失，是否继续前往新增模版?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$router.push('/activity_form_add')
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消' })
        })
    },
    setImg(key, val) {
      this.form[key] = val
    },
    chang(val) {
      this.form.content = val
    },
    getTemplateIds() {
      const list =
        (this.$refs.activityFormEdit &&
          this.$refs.activityFormEdit.configFormData &&
          this.$refs.activityFormEdit.configFormData.list) ||
        []
      return list
        .map((item) => item.id)
        .filter((id) => id != null && id !== '')
        .join(',')
    },
    processForm() {
      const payload = {
        ...this.form,
        industryIds: this.form.industryIds,
        viewAd: this.form.joinType == 1 ? this.form.viewAd : 0,
        activityId: this.form.activityId || 0,
        templatelds: this.getTemplateIds()
      }
      if (this.id) payload.id = this.id
      return payload
    },
    submit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          this.$message.warning('请完善必填信息')
          this.$nextTick(() => {
            const errorEl = this.$el.querySelector('.el-form-item.is-error')
            if (errorEl) {
              errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          return
        }
        this.loading = true
        const url = this.id ? '/admin/Community/edit' : '/admin/Community/add'
        try {
          const { data: res } = await this.$http.post(url, this.processForm())
          if (res.errorCode == 200) {
            this.$message.success(res.message)
            this.$router.push('/community_list')
          }
        } finally {
          this.loading = false
        }
      })
    },
    goBack() {
      this.$router.push('/community_list')
    }
  }
}
</script>

<style lang="less" scoped>
.ml {
  margin-left: 10px;
}
.selected-industry-tags {
  margin-bottom: 8px;
  .el-tag {
    margin: 0 8px 8px 0;
  }
}
.select-empty-box {
  padding: 10px 0;
  text-align: center;
  color: #999;
  p {
    margin: 0 0 4px;
  }
}
</style>

<style lang="less">
.community-category-cascader {
  .el-cascader-panel .el-cascader-node {
    position: relative;
  }
  .el-cascader-panel .el-radio {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
  .el-cascader-panel .el-radio__input {
    display: none;
  }
  .el-cascader-panel .el-radio__label {
    display: none;
  }
}
</style>
